import { useState } from "react"
import "./FaqPage.scss"
const faqArray = require("./faq-static")

export default function FaqPage() {
  const [faqRow, setfaqRow] = useState(0)
  const faqToggle = (data) => {
    console.log(data)
    setfaqRow(data)
  }
  return (
    <>
      <section className="aboutPage">
        <div className="container">
          <div className="col-12 innerBAnner">
            <div className="mx-auto text-center">
              <h1>Frequently asked questions</h1>
            </div>
          </div>
        </div>

        <div className="aboutLayerTwo">
          <div className="container">
            <div className="row align-items-center pt-md-5"></div>
            <div className="row">
              {faqArray.map((data, ind) => (
                <div className="col-md-12">
                  <div className="faq-row">
                    <div
                      className="d-flex align-items-end  faq-head"
                      onClick={() => faqToggle(ind)}
                    >
                      <b>{ind + 1}</b>
                      <h4 className="me-auto">{data.question}</h4>
                      <span>
                        {faqRow === ind ? (
                          <svg
                            width="19"
                            height="30"
                            viewBox="0 0 19 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18.1189 14.6937L16.4545 12.95L4.40707 0.268555L0.731445 3.75596L11.1243 14.6937L0.731445 25.6315L4.40707 29.1189L16.4545 16.4374L18.1189 14.6937Z"
                              fill="#353535"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="29"
                            height="18"
                            viewBox="0 0 29 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.4254 17.3875L16.1691 15.723L28.8506 3.67563L25.3632 -1.52439e-07L14.4254 10.3928L3.48764 -1.10865e-06L0.000232541 3.67563L12.6817 15.723L14.4254 17.3875Z"
                              fill="#353535"
                            />
                          </svg>
                        )}
                      </span>
                    </div>
                    {faqRow === ind && (
                      <div className="faq-body">
                        <p>{data.answer}</p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/*}
        <div className="aboutLayerOne">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-xl-5 text-end mb-5 mb-lg-0">
                <figure>
                  <img src="img/img14.png" alt="" />
                </figure>
              </div>
              <div className="col-lg-6 ps-lg-5  ms-md-auto text-center text-lg-start">
                <h1 className="mb-md-4">We use the positive power</h1>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s,
                </p>
                <h2>Having a global impact</h2>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text
                </p>
                <a href="">
                  <svg
                    width="188"
                    height="53"
                    viewBox="0 0 188 53"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      width="188"
                      height="53"
                      rx="26.5"
                      fill="currentColor"
                    />
                    <path
                      d="M61.88 33H68C72.54 33 75.64 30.2 75.64 26C75.64 21.8 72.54 19 68 19H61.88V33ZM64.48 30.8V21.2H67.88C71 21.2 73.02 23.1 73.02 26C73.02 28.9 71 30.8 67.88 30.8H64.48ZM82.9634 33.14C86.2834 33.14 88.6634 30.86 88.6634 27.66C88.6634 24.46 86.2834 22.2 82.9634 22.2C79.6834 22.2 77.2834 24.46 77.2834 27.66C77.2834 30.86 79.6834 33.14 82.9634 33.14ZM82.9634 31C81.1634 31 79.8034 29.7 79.8034 27.66C79.8034 25.62 81.1634 24.32 82.9634 24.32C84.7834 24.32 86.1434 25.62 86.1434 27.66C86.1434 29.7 84.7834 31 82.9634 31ZM105.201 22.32L102.301 30.24L99.4211 22.32H97.3211L94.3811 30.2L91.5611 22.32H89.2011L93.1211 33H95.5211L98.3211 25.64L101.081 33H103.481L107.421 22.32H105.201ZM115.2 22.2C113.64 22.2 112.34 22.72 111.52 23.7V22.32H109.14V33H111.64V27.6C111.64 25.46 112.84 24.38 114.62 24.38C116.22 24.38 117.16 25.3 117.16 27.2V33H119.66V26.88C119.66 23.66 117.76 22.2 115.2 22.2ZM122.831 33H125.331V18.16H122.831V33ZM133.413 33.14C136.733 33.14 139.113 30.86 139.113 27.66C139.113 24.46 136.733 22.2 133.413 22.2C130.133 22.2 127.733 24.46 127.733 27.66C127.733 30.86 130.133 33.14 133.413 33.14ZM133.413 31C131.613 31 130.253 29.7 130.253 27.66C130.253 25.62 131.613 24.32 133.413 24.32C135.233 24.32 136.593 25.62 136.593 27.66C136.593 29.7 135.233 31 133.413 31ZM145.447 22.2C143.727 22.2 142.067 22.64 140.927 23.52L141.907 25.34C142.707 24.68 143.947 24.28 145.147 24.28C146.927 24.28 147.807 25.14 147.807 26.6V26.76H145.047C141.807 26.76 140.607 28.16 140.607 29.94C140.607 31.8 142.147 33.14 144.587 33.14C146.187 33.14 147.347 32.62 147.947 31.7V33H150.307V26.74C150.307 23.66 148.527 22.2 145.447 22.2ZM145.107 31.32C143.827 31.32 143.067 30.74 143.067 29.84C143.067 29.06 143.527 28.42 145.227 28.42H147.807V29.66C147.387 30.76 146.327 31.32 145.107 31.32ZM161.573 18.16V23.64C160.733 22.66 159.513 22.2 158.133 22.2C155.033 22.2 152.733 24.34 152.733 27.66C152.733 30.98 155.033 33.14 158.133 33.14C159.593 33.14 160.833 32.64 161.673 31.62V33H164.073V18.16H161.573ZM158.433 31C156.633 31 155.253 29.7 155.253 27.66C155.253 25.62 156.633 24.32 158.433 24.32C160.233 24.32 161.613 25.62 161.613 27.66C161.613 29.7 160.233 31 158.433 31Z"
                      fill="white"
                    />
                    <path
                      d="M39.2013 14C39.3888 15.6836 38.8263 17.127 37.7169 18.3594C36.8204 19.3555 35.6974 19.9551 34.3224 20.0078C34.2735 20.0098 34.2267 20.0078 34.1622 20.0078C34.0509 19.4297 34.0724 18.8613 34.2345 18.3145C34.8985 16.0527 36.4044 14.6582 38.6798 14.0742C38.7872 14.0469 38.8985 14.0254 39.0059 14C39.0704 14 39.1368 14 39.2013 14Z"
                      fill="white"
                    />
                    <path
                      d="M44.4609 22.3828C42.496 23.5684 41.4921 25.2969 41.6816 27.5879C41.8671 29.8496 43.0819 31.4336 45.1952 32.3574C45.0878 32.5938 44.9862 32.8301 44.8749 33.0625C44.0722 34.7461 43.0937 36.3145 41.8007 37.6699C41.3437 38.1485 40.8241 38.5586 40.1972 38.8027C39.3183 39.1445 38.4706 39.0098 37.6425 38.6231C36.9843 38.3164 36.3144 38.0488 35.58 37.9746C34.4882 37.8652 33.4569 38.0664 32.4706 38.5332C31.9687 38.7715 31.4491 38.961 30.8866 38.9942C30.0585 39.043 29.3359 38.7578 28.6874 38.2637C27.7441 37.5469 27.0527 36.6133 26.414 35.6367C25.1581 33.7207 24.3105 31.6426 23.9648 29.3731C23.7089 27.6895 23.7343 26.0176 24.2831 24.3828C24.7441 23.0098 25.6054 21.9297 26.7519 21.0703C27.6132 20.4258 28.5702 19.9961 29.6542 19.8828C30.5312 19.791 31.373 19.9531 32.2011 20.2266C32.7577 20.4102 33.3085 20.6113 33.871 20.7734C34.8085 21.041 35.7226 20.9082 36.6171 20.5547C37.3749 20.2559 38.1425 19.9902 38.9589 19.8945C40.4218 19.7227 41.7323 20.1211 42.9296 20.9395C43.5097 21.3379 44.0175 21.8164 44.4609 22.3828Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
                    */}
      </section>
    </>
  )
}
